// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H1S0","textarea":"styles_textarea__2nXKf"};